import {gql} from '@apollo/client';

export const UPSERT_NOTIFICATION_BUCKET = gql`
  mutation UpsertNotificationBucket($input: UpsertNotificationBucketInput!) {
    upsertNotificationBucket(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationBucket {
        message
        data {
          id
          key
          name
          description
          cooldownHours
          dropPolicy
          dropAfterShiftHours
          requiresApproval
          defaultApprovers
          active
        }
      }
    }
  }
`;

export const UPSERT_NOTIFICATION_WORKFLOW = gql`
  mutation UpsertNotificationWorkflow(
    $input: UpsertNotificationWorkflowInput!
  ) {
    upsertNotificationWorkflow(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationWorkflow {
        message
        data {
          id
          workflowKey
          name
          description
          bucket
          priority
          active
        }
      }
    }
  }
`;
